import React, { FunctionComponent, useState } from 'react';

import { SingleYesNoStep } from 'scenes/common/components/Steps';
import { getIsUsedForBusiness } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import { WhenAnswerYesModal } from './WhenAnswerYesModal';

const STATE_KEY = 'isUsedForBusiness';
const QUESTION = 'Is the car used for business purposes?';

const UsedForBusinessStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [showModal, setShowModal] = useState(false);
  const helpLink = {
    id: 'when-answer-yes-link',
    text: 'When to answer yes?',
    ariaLabel: 'When to answer yes? Opens dialog',
    onClick: () => setShowModal(true),
  };
  return (
    <>
      <SingleYesNoStep
        question={QUESTION}
        stateKey={STATE_KEY}
        defaultStateValue={getIsUsedForBusiness(funnelState)}
        onNext={onNext}
        helpLink={helpLink}
      />
      <WhenAnswerYesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default UsedForBusinessStep;
